import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { uniqBy } from 'lodash';

import { exportItems } from '../MintWeapons/utils';
import { fetchOwnerships } from '../../actions/ownership';

function useMyWeapon(props) {
    const dispatch = useDispatch();

    const { offset, isConnected } = props;

    const [weaponList, setWeaponList] = useState([]);
    const [hasMore, setHasMore] = useState(false);
    const [firstLoad, setFirstLoad] = useState(false);

    const account = useSelector(state => state.user?.userAccount?.accounts[0] ?? '');
    const wrongNetwork = useSelector(state => state.common?.wrongNetwork);
    const mintedRes = useSelector(state => state.ownership?.mintedRes?.result);

    useEffect(() => {
        if (isConnected) { 
            return setFirstLoad(true);
        }

        return setWeaponList([]);
    }, [isConnected, account]);

    /* LOAD FIRST */
    useEffect(() => {
        if (wrongNetwork) return;
        if (!isConnected) return;
        if (offset > 0) return;

        dispatch(fetchOwnerships('', account, 10, 0))
            .then(res => {
                setFirstLoad(false);
                setWeaponList(() => exportItems(res?.data));
                setHasMore(res?.data?.length > 9);
            })
            .catch(err => {
                return err;
            })
    }, [
        dispatch,
        offset,
        account,
        mintedRes,

        isConnected,
        wrongNetwork
    ]);

    /* LOAD MORE */
    useEffect(() => {
        if (!isConnected) return;
        if (offset === 0) return;

        dispatch(fetchOwnerships('', account, 10, offset))
            .then(res => {
                setFirstLoad(false);
                setWeaponList(prevState => uniqBy([...prevState, ...exportItems(res?.data)], 'id'));
                setHasMore(res?.data?.length > 9);
            })
            .catch(err => {
                return err;
            })
    }, [
        dispatch,
        offset,
        account,
        mintedRes,
        isConnected
    ]);

    return { weaponList, hasMore, firstLoad };
}

export default useMyWeapon;